import { inject, Pipe, PipeTransform } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

export type LabelCaseExceptions = {
  skipWords?: string[];
  titleCaseWords?: string[];
  capitalCaseWords?: string[];
};

@Pipe({
  name: 'labelCase',
})
export class LabelCasePipe implements PipeTransform {
  private readonly _titleCase = inject(TitleCasePipe);
  transform(
    value: string,
    exceptions: LabelCaseExceptions = {
      skipWords: [],
      titleCaseWords: [],
      capitalCaseWords: [],
    },
  ): string {
    if (!value || !value.length) {
      return '';
    }
    if (exceptions.skipWords?.includes(value)) {
      return value;
    }
    if (exceptions.titleCaseWords?.includes(value)) {
      return this._titleCase.transform(value);
    }

    if (exceptions.capitalCaseWords?.includes(value)) {
      return value.toUpperCase();
    }

    const _value = value.replace(/([A-Z])/g, ' $1').trim();
    return this._titleCase.transform(_value);
  }
}
